// src/api/client.js
import api from './axios';

const apiClient = {

    getHomeContent: async () => {
        try {
            const response = await api.get('/home_content/all');
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching home content:', error);
            throw error;
        }
    },

    getLatestYoutubeVideo: async () => {
        try {
            // Mendefinisikan endpoint API dan API key secara terpisah
            const API_KEY = 'a2FrYWJhMjAyNEpheWEh';
            const response = await api.get(`/home/youtube?api_key=${API_KEY}`);

            // console.log(response.data.data);
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching latest YouTube video:', error);
            throw new Error('Gagal mengambil video YouTube terbaru. Periksa kembali endpoint API.');
        }
    },

    getAnnouncements: async () => {
        try {
            const response = await api.get('/home_content/all');
            // console.log(response.data.data.pengumuman)
            return response.data.data.pengumuman;
        } catch (error) {
            // console.error('Error fetching announcements:', error);
            return [];
        }
    },

    // getWartaJemaatList: async (page = 1) => {
    //     try {
    //         const response = await api.get(`/warta_jemaat/list?page=${page}`);
    //         return {
    //             wartaList: response.data?.data?.data || [],
    //             totalPages: response.data?.data?.last_page || 0,
    //         };
    //     } catch (error) {
    //        // console.error('Error fetching warta jemaat list:', error);
    //         throw error;
    //     }
    // },

    getWartaJemaatList: async (page = 1) => {
        try {
            // Tetap hanya mengirim page karena API tidak kenal year/month
            const response = await api.get(`/warta_jemaat/list?page=${page}`);
            return {
                wartaList: response.data?.data?.data || [],
                totalPages: response.data?.data?.last_page || 0,
            };
        } catch (error) {
            // console.error('Error fetching warta jemaat list:', error);
            throw error;
        }
    },

    getWartaJemaatDetail: async (id) => {
        try {
            const response = await api.get(`/warta_jemaat/detail/${id}`);
            return response.data.data;
        } catch (error) {
            // console.error(`Error fetching warta jemaat detail for id ${id}:`, error);
            throw error;
        }
    },

    getBeritaDukaList: async () => {
        try {
            const response = await api.get('/berita_duka/list');
            return response.data.data.data;
        } catch (error) {
            // console.error('Error fetching berita duka list:', error);
            throw error;
        }
    },

    // TI Minggu list
    getTataIbadahMingguList: async (page = 1) => {
        try {
            const response = await api.get(`/ti_minggu/list?page=${page}`);
            return {
                ibadahList: response.data.data.ti_minggu,
                totalPages: response.data.data.total_pages,
            };
        } catch (error) {
            // console.error('Error fetching tata ibadah minggu list:', error);
            throw error;
        }
    },

    // TI Minggu Detail
    getTataIbadahMingguDetail: async (id) => {
        try {
            const response = await api.get(`/ti_minggu/detail/${id}`);
            return response.data.data;
        } catch (error) {
            // console.error(`Error fetching tata ibadah minggu detail for id ${id}:`, error);
            throw error;
        }
    },

    // TI Keluarga List
    getTataIbadahKeluargaList: async (page = 1) => {
        try {
            const response = await api.get(`/ti_ika/list?page=${page}`);
            return {
                ibadahList: response.data.data.ti_keluarga,
                totalPages: response.data.data.total_pages,
            };
        } catch (error) {
            // console.error('Error fetching tata ibadah keluarga list:', error);
            throw error;
        }
    },

    // TI Keluarga Detail
    getTataIbadahKeluargaDetail: async (id) => {
        try {
            const response = await api.get(`/ti_ika/detail/${id}`);
            return response.data.data;
        } catch (error) {
            // console.error(`Error fetching tata ibadah keluarga detail for id ${id}:`, error);
            throw error;
        }
    },

    // TI Pelkat Category
    getTataIbadahPelkatPercategory: async (pelkat) => {
        try {
            const response = await api.get(`/ti_pelkat/list/${pelkat}`);
            // console.log(response.data.data)
            return response.data.data;
        } catch (error) {
            // console.error(`Error fetching tata ibadah pelkat category for id ${pelkat}:`, error);
            throw error;
        }
    },

    // TI Pelkat Category
    getTataIbadahPelkatDetail: async (id) => {
        try {
            const response = await api.get(`/ti_pelkat/detail/${id}`);
            const resData = response.data.data;
            // console.log(resData)

            // Cek jika API mengembalikan paginasi bukannya objek tunggal
            if (resData && resData.data && Array.isArray(resData.data)) {
                return resData.data[0]; // Ambil item pertama dari array data
            }

            return resData; // Kembalikan langsung jika sudah berupa objek
        } catch (error) {
            // console.error(`Error fetching detail for id ${id}:`, error);
            throw error;
        }
    },

    // TI Pelkat Category
    getTataIbadahKhususCategories: async () => {
        try {
            const response = await api.get('/ti_khusus/categories');
            // console.log(response.data.data)
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching ti khusus categories:', error);
            throw error;
        }
    },

    // TI Pelkat Category
    getTataIbadahKhususDetail: async (id) => {
        try {
            const response = await api.get(`/ti_khusus/detail/${id}`);
            const resData = response.data.data;
            // console.log(resData)

            // Cek jika API mengembalikan paginasi bukannya objek tunggal
            if (resData && resData.data && Array.isArray(resData.data)) {
                return resData.data[0]; // Ambil item pertama dari array data
            }

            return resData; // Kembalikan langsung jika sudah berupa objek
        } catch (error) {
            // console.error(`Error fetching detail for id ${id}:`, error);
            throw error;
        }
    },

    getKmjList: async () => {
        try {
            const response = await api.get('/kmj/list');
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching KMJ list:', error);
            throw error;
        }
    },

    getPendetaList: async () => {
        try {
            const response = await api.get('/pendeta/list');
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching pendeta list:', error);
            throw error;
        }
    },

    getPhmjList: async () => {
        try {
            const response = await api.get('/phmj/list');
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching PHMJ list:', error);
            throw error;
        }
    },

    getKorsekList: async () => {
        try {
            const response = await api.get('/korsek/list');
            return response.data.data;
        } catch (error) {
            // console.error('Error fetching korsek list:', error);
            throw error;
        }
    },

    // Absen GP
    createAbsenGp: async (data) => {
        try {
            const response = await api.post('/absen_gp/absen', data)
            // console.log('DEBUG CLIENT: Absensi berhasil, respon:', response.data);
            return response.data;
        } catch (error) {
            // console.error('Error create Absen GP:', error);
            throw error;
        }
    },

    // Absen PT
    createAbsenPt: async (data) => {
        try {
            const response = await api.post('/absen_pt/absen', data)
            // console.log('DEBUG CLIENT: Absensi berhasil, respon:', response.data);
            return response.data;
        } catch (error) {
            //// console.error('Error create Absen PT:', error);
            throw error;
        }
    },

    getSektor: async () => {
        const API_KEY = 'gpibkkbbmantap2023'
        try {
            const response = await api.get(`/absen/sektors?api_key=${API_KEY}`)
            // console.log(response.data.data)
            return response.data.data;
        } catch (e) {
            // console.log(e)
            throw e;
        }
    },
    // New
    getSektorList: async () => {
        try {
            const response = await api.get('/sektor');
            // console.log(response.data.data)
            return response.data.data;
        } catch (e) {
            throw e;
        }
    },

    getPelkat: async (id) => {
        try {
            const response = await api.get(`/pelkat/${id}`)
            return response.data.data;
        } catch (e) {
            // console.log(e)
            throw e;
        }
    },

    getKomisi: async (slug) => {
        try {
            const response = await api.get(`/komisi/${slug}`)
            return response.data.data;
        } catch (e) {
            // console.log(e)
            throw e;
        }
    },
    getKomisiList: async () => {
        try {
            const response = await api.get(`/komisi`)   // ✅ tanpa trailing slash
            return response.data.data;
        } catch (e) {
            throw e;
        }
    },

    getPresbiter: async (slug) => {
        try {
            const response = await api.get(`/presbiter/${slug}`)
            return response.data.data;
        } catch (e) {
            // console.log(e)
            throw e;
        }
    },

    // NEW
    // ===== FORMULIR (dinamis) =====
    getFormulirList: async () => {
        const response = await api.get('/formulir/all'); // endpoint baru (bukan /formulir/list)
        return response.data.data;
    },

    getFormulirByCode: async (formCode) => {
        const response = await api.get('/formulir/list', {
            params: { form_code: formCode },
        });
        return response.data.data;
    },

    getFileUrl: (path) => {
        if (typeof path !== 'string' || !path) return null;
        if (path.startsWith('http')) return path;
        return `https://filehs.gpibkasihkaruniabadungbali.org/${path.replace(/^\/+/, '')}`;
    },
};

export default apiClient;